import { render, staticRenderFns } from "./MemberAdd.vue?vue&type=template&id=1f3322e2&"
import script from "./MemberAdd.vue?vue&type=script&lang=js&"
export * from "./MemberAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports